/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { useSummaryDisplay } from "./hooks";
import { useSelector } from "react-redux";
import { IFullDeviceDetails } from "../../../store/api/deviceConfig/types";
import { deviceDataCountSelector, selectedDeviceSelector } from "../../../store/api/devices/selectors";
import { prepareDeviceConfigDetail, prepareDeviceDataCountForSummary } from "../helpers";
import SummaryDisplayGrid from "../../../components/Configuration/Summary/SummaryDisplayGrid";
import { IdeviceCounts } from "../../../store/api/devices/types";

const Summary: React.FC = () => {
  const { isLoading } = useSummaryDisplay();

  const deviceDataCount: IdeviceCounts = useSelector(deviceDataCountSelector);
  const selectedDevice: IFullDeviceDetails = useSelector(selectedDeviceSelector);

  return (
    <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
      <div style={{ width: "100%" }}>
        {isLoading && <p>Loading...</p>}
        {!isLoading && <SummaryDisplayGrid rowData={prepareDeviceConfigDetail(selectedDevice, deviceDataCount?.uptime)} rowHeader={prepareDeviceDataCountForSummary(deviceDataCount, selectedDevice?.nodeType)} />}
      </div>
    </div>
  );
};

export default Summary;
